<template>
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="icons/minus">
      <path
        id="Union"
        d="M21 11.0002V14.0002L4 14.0002L4 11.0002L21 11.0002Z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>
